export function observeElementRect(n, o) {
  const i = e.get(n);
  return void 0 === i ? (e.set(n, {
    rect: {},
    callbacks: [o]
  }), 1 === e.size && (t = requestAnimationFrame(c))) : (i.callbacks.push(o), o(n.getBoundingClientRect())), () => {
    const c = e.get(n);
    if (void 0 === c) return;
    const i = c.callbacks.indexOf(o);
    i > -1 && c.callbacks.splice(i, 1), 0 === c.callbacks.length && (e.delete(n), 0 === e.size && cancelAnimationFrame(t));
  };
}
let t;
const e = new Map();
function c() {
  const n = [];
  e.forEach((t, e) => {
    const c = e.getBoundingClientRect();
    var o, i;
    o = t.rect, i = c, (o.width !== i.width || o.height !== i.height || o.top !== i.top || o.right !== i.right || o.bottom !== i.bottom || o.left !== i.left) && (t.rect = c, n.push(t));
  }), n.forEach(t => {
    t.callbacks.forEach(e => e(t.rect));
  }), t = requestAnimationFrame(c);
}